import { TelegramAuthData } from '@telegram-auth/react';
import axiosInstance from './axios';
import { TelegramAuthResponse } from 'features/auth/types';

// API request for registering a user
export const registerUser = async (data: {
  display_name: string;
  username: string;
  password: string;
}) => {
  const response = await axiosInstance.public.post('/api/v1/auth/register', data);
  return response.data;
};

// API request for logging in a user
export const loginUser = async (data: {
  username: string;
  password: string;
}) => {
  const response = await axiosInstance.public.post('/api/v1/auth/login', data);
  return response.data;
}

// API request for Telegram OAuth
export const authenticateWithTelegram = async (authData: TelegramAuthData): Promise<TelegramAuthResponse> => {
  const response = await axiosInstance.public.post<TelegramAuthResponse>('/api/v1/auth/telegram', {
    auth_data: authData, 
  });
  return response.data;
};

export const googleOAuthCallback = async (code: string) => {
  const response = await axiosInstance.public.post(`/api/v1/auth/google-callback?code=${code}`);
  return response.data;
};

export const connectTelegram = async (authData: TelegramAuthData): Promise<TelegramAuthResponse> => {
  const response = await axiosInstance.private.post<TelegramAuthResponse>('/api/v1/auth/telegram', {
    auth_data: authData, 
  });
  return response.data;
};

export const connectGoogle = async (code: string) => {
  const response = await axiosInstance.private.post(`/api/v1/auth/google-callback?code=${code}`);
  return response.data;
};


// Logout API request
export const logoutUser = async () => {
  const response = await axiosInstance.private.post('/api/v1/auth/logout');
  return response.data;
};

interface UpdateUserData {
  email?: string | null;
  phone?: string | null;
  display_name?: string | null;
  img_url?: string | null;
  is_deleted?: boolean | null;
}

// Update user profile
export const updateUser = async (data: UpdateUserData) => {
  // Clean up the data object by removing undefined and empty string values
  const cleanData = Object.entries(data).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, any>);

  const response = await axiosInstance.private.patch('/api/v1/auth/user', cleanData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

interface UpdatePasswordData {
  old_password: string;
  new_password1: string;
  new_password2: string;
}

// Update password API request
export const updatePassword = async (data: UpdatePasswordData) => {
  try {
    const response = await axiosInstance.private.put('/api/v1/auth/update-password', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    // Handle specific error cases
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to update password');
  }
};
